import { Flex } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";

export default function HeaderTable() {
  return (
    <Flex bg={colors.black75} roundedTop={15} px={4} h="60px" align="center">
      <Flex flex={4} fontWeight="medium">
        Item
      </Flex>
      <Flex flex={1} fontWeight="medium">
        Quantidade
      </Flex>
      <Flex flex={1} fontWeight="medium"  justifyContent="flex-end">
        Valor Unitário
      </Flex>
      <Flex flex={1.5} fontWeight="medium"  justifyContent="flex-end">
        Valor Total
      </Flex>
    </Flex>
  );
}
